import React, { useMemo, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import useClickOutside from '../hooks/useClickOutside';
import useEscapeKey from '../hooks/useEscapeKey';
import RippleButton from './RippleButton';

export default function UserMenu({ user, onLogout, onThemeToggle, theme }) {
  const [open, setOpen] = React.useState(false);
  const rootRef = useRef(null);

  useClickOutside(rootRef, () => setOpen(false));
  useEscapeKey(open, () => setOpen(false));

  const initials = useMemo(() => user?.name?.[0]?.toUpperCase() || 'U', [user]);

  return (
    <div className="user-menu" ref={rootRef}>
      <RippleButton className="topbar__avatar" type="button" onClick={() => setOpen((v) => !v)}>
        {initials}
      </RippleButton>

      <AnimatePresence>
        {open && (
          <motion.div
            className="user-menu__panel"
            initial={{ opacity: 0, y: 8, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 6, scale: 0.99 }}
            transition={{ duration: 0.16 }}
            role="menu"
            aria-label="User menu"
          >
            <div className="user-menu__header">
              <div className="user-menu__name">{user?.name}</div>
              <div className="user-menu__email">{user?.email}</div>
            </div>
            <button className="user-menu__item" type="button" onClick={() => onThemeToggle()}>
              {theme === 'dark' ? 'Switch to Light' : 'Switch to Dark'}
            </button>
            <button className="user-menu__item user-menu__item--danger" type="button" onClick={onLogout}>
              Logout
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

